import { render, staticRenderFns } from "./healthplantzbs.vue?vue&type=template&id=6847712c&scoped=true&"
import script from "./healthplantzbs.vue?vue&type=script&lang=js&"
export * from "./healthplantzbs.vue?vue&type=script&lang=js&"
import style0 from "./healthplantzbs.vue?vue&type=style&index=0&id=6847712c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6847712c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6847712c')) {
      api.createRecord('6847712c', component.options)
    } else {
      api.reload('6847712c', component.options)
    }
    module.hot.accept("./healthplantzbs.vue?vue&type=template&id=6847712c&scoped=true&", function () {
      api.rerender('6847712c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/physical/healthplantzbs.vue"
export default component.exports